import { useApiClient } from '@m43/core';
import { AssigneventResource, UnitStatus } from '@mark43/cad-api';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios-cad-nx';

interface ApiErrorBody {
    error?: string;
}

export function useUnitAssignSelfToEventMutation({ holdEventForPreemptUnit = false } = {}) {
    const apiClient = useApiClient();
    return useMutation<
        AxiosResponse<AssigneventResource.AssignSelfToEvent1['returns']>,
        AxiosError<ApiErrorBody>,
        UnitStatus
    >((args) => {
        return apiClient.request<AssigneventResource.AssignSelfToEvent1>({
            method: 'POST',
            url: 'assign/event/unit/self/',
            params: {
                preempt: !!holdEventForPreemptUnit,
            },
            data: args,
        });
    });
}
